// extracted by mini-css-extract-plugin
export default {"splitter":"Splitter_splitter__zKIR+"};